Alpine.store('requested', {
    total: 0,

    async syncData(url) {
        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                this.total = data?.total ?? 0;
            })
            .catch((error) => {
                console.error('Error fetching request counter data:', error);
            });
    },
});
